// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type VersionBadge_VersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined };

export type VersionBadge_ProductOfferingFragment = { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } };

export type VersionBadge_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, pricingTraceUrl?: { __typename?: 'Url', url: string } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, productOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } } | null | undefined, aduAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } | null | undefined, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } } | null | undefined };

export const VersionBadge_VersionFragmentDoc = gql`
    fragment VersionBadge_Version on ReadyPlanAggregateVersion {
  id
  version
}
    `;
export const VersionBadge_ProductOfferingFragmentDoc = gql`
    fragment VersionBadge_ProductOffering on ProductOffering {
  id
  aggregateCheckout {
    ...VersionBadge_Version
  }
  aggregateLatest {
    ...VersionBadge_Version
  }
}
    ${VersionBadge_VersionFragmentDoc}`;
export const VersionBadge_CheckoutConfigFragmentDoc = gql`
    fragment VersionBadge_CheckoutConfig on CheckoutConfig {
  id
  pricingTraceUrl {
    url
  }
  aggregateVersion {
    ...VersionBadge_Version
  }
  productOffering {
    ...VersionBadge_ProductOffering
  }
  aduAggregateVersion {
    ...VersionBadge_Version
  }
  aduProductOffering {
    ...VersionBadge_ProductOffering
  }
}
    ${VersionBadge_VersionFragmentDoc}
${VersionBadge_ProductOfferingFragmentDoc}`;